import { useQuery } from "@tanstack/react-query"
import { useAuthEmployeeQuery } from "../../auth/hooks/useAuthEmployeeQuery"
import { segmentGroupsQuery } from "../lib/segmentGroupsQuery"

export function useSegmentGroupsQuery(options?: Parameters<typeof segmentGroupsQuery>[1]) {
  const { data: employee } = useAuthEmployeeQuery()
  return useQuery(segmentGroupsQuery(employee?.companyId ?? "", options))
}
